import "./Auth.css";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../components/Logo/Logo";
import { sendPasswordResetEmail } from "firebase/auth";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFirebase } from "../../../contexts/FirebaseContext";
import SharedPageWrapper from "../../components/SharedPageWrapper/SharedPageWrapper";
import { TextField } from "@mui/material";

export default function ForgotPassword() {
    const { auth } = useFirebase();
    const [email, setEmail] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();
    const location = useLocation();

    // Determine game theme from URL params or location state
    const searchParams = new URLSearchParams(location.search);
    const game = searchParams.get('game') || location.state?.game || 'mk8dx';

    const resetPasswordEmail = (e) => {
        e.preventDefault();
        setErrorMessage("");

        sendPasswordResetEmail(auth, email)
            .then(() => {
                alert("Email sent. Check your spam if it doesn't reach your inbox.");
                navigate(`/signin?game=${game}`, { replace: true });
            })
            .catch((e) => setErrorMessage(e.message));
    }

    return <SharedPageWrapper game={game}>
        <div id="auth-container">
        <div id="form-title">
            <Logo game={game} />
            <h1>Forgot Password</h1>
        </div>
        <form className="auth-form" onSubmit={resetPasswordEmail}>

            <h3 id="auth-error">{errorMessage}</h3>

            <TextField
                label="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                variant="outlined"
                className="auth-textfield"
                sx={{
                    width: '350px',
                    marginBottom: '20px',
                    '& .MuiOutlinedInput-root': {
                        color: 'white',
                        backgroundColor: '#555',
                        '& fieldset': {
                            borderColor: '#777',
                        },
                        '&:hover fieldset': {
                            borderColor: 'white',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: 'white',
                        },
                    },
                    '& .MuiInputLabel-root': {
                        color: '#aaa',
                        fontFamily: 'var(--ui-font-family)',
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                        color: 'white',
                    },
                    '& input': {
                        fontFamily: 'var(--ui-font-family)',
                    },
                }}
            />

            <input type="submit" value="Reset Password" className="icon-button" />

            <Link to={`/signin?game=${game}`} state={{ yourCup: location.state?.yourCup, game }}>Return to Sign In</Link>

        </form>

    </div>
    </SharedPageWrapper>
}